// This file is auto-generated by @hey-api/openapi-ts

export type AddCommentRequest = {
  report_id: string;
  message: string;
};

export type AddCommentResponse = {
  report: ReportResponse;
};

export type AddManualAddressRequest = {
  report_id: string;
  address: RawAddress;
};

export type AddManualAddressResponse = {
  report: ReportResponse;
};

export type AddSavedFilterRequest = {
  url: string;
  nickname: string;
  is_default: boolean;
};

export type AdditionalAssigneeInfo = {
  assignees: {
    [key: string]: string;
  };
};

export type Address = {
  address_id: string;
  is_deleted?: boolean | null;
  default_sort_key?: string | null;
  private_computed_values: RawAddress;
  private_original_values: {
    [key: string]: string | null;
  };
  private_overrides: {
    [key: string]: string | number | null;
  };
  private_flags: {
    [key: string]: Array<
      | "missing_coverage_headers"
      | "date_parsing_error"
      | "number_parsing_error"
      | "large_number_warning"
      | "suspicious_year_warning"
      | "year_out_of_range_warning"
      | "general_mismatch"
      | "low_confidence"
      | "medium_confidence"
      | "non_property_insurance_value"
      | "unrecognized_central_alarm_value"
      | "unrecognized_yes_no_value"
      | "low_sprinkler_percentage"
      | "unrecognized_sprinkler_value"
      | "zip_parsing_error"
      | "blank_tiv_value"
      | "non_ascii_removed"
      | "address_corrected_by_geocoding"
      | "geocoding_failed"
      | "location_number_mismatch"
      | "year_defaulted_to_year_built"
      | "approximate_geocoding"
      | "high_protection_class"
      | "tier_1_wind_zone"
      | "itv_calc_warning"
      | "bi_estimate_warning"
      | "coverage_adjusted_by_reconciliation"
      | "zip_unrecognized"
      | "zip_not_rater_valid"
      | "zip_state_mismatch"
      | UnknownCoverageColumnFlag
      | UnknownInsuranceSubjectFlag
      | AddressCorrectedByModel
      | AddressFlaggedByGeocoding
      | CoverageComputedFromColumnSum
    >;
  };
  ofac_result?: OfacResult | null;
};

export type AddressCorrectedByModel = {
  flag_id: "address_corrected_by_llm_parse";
  original: string;
};

export type AddressFlaggedByGeocoding = {
  flag_id: "address_flagged_by_geocoding";
  geocoded: string | null;
};

export type AdvancedDeductible = {
  peril_type:
    | "aop"
    | "earthquake"
    | "earth_movement"
    | "named_storm"
    | "scs"
    | "flood"
    | "wildfire"
    | "equipment_breakdown"
    | "wind_and_hail";
  short_deductible_description: string;
  executable_python_function_str: string;
  direct_excerpts?: {
    [key: string]: string;
  } | null;
  manual_excerpt_overrides?: {
    [key: string]: string;
  } | null;
};

export type AdvancedDeductibleInfo = {
  extracted_deductibles: {
    [key: string]: {
      [key: string]: AdvancedDeductible;
    };
  };
  manual_deductibles: {
    [key: string]: AdvancedDeductible;
  };
};

export type AdvancedLimit = {
  peril_type:
    | "aop"
    | "earthquake"
    | "earth_movement"
    | "named_storm"
    | "scs"
    | "flood"
    | "wildfire"
    | "equipment_breakdown"
    | "wind_and_hail";
  short_limit_description: string;
  document_quotation: string;
  executable_python_function_str: string;
  direct_excerpts?: {
    [key: string]: string;
  } | null;
  manual_excerpt_overrides?: {
    [key: string]: string;
  } | null;
};

export type AdvancedLimitInfo = {
  extracted_limits: {
    [key: string]: {
      [key: string]: AdvancedLimit;
    };
  };
  manual_limits: {
    [key: string]: AdvancedLimit;
  };
};

export type AllPivotsResult = {
  pivots: {
    [key: string]: PivotTableResult;
  };
};

export type Appetite = {
  appetite_result:
    | "in_appetite"
    | "sic_codes_invalid"
    | "no_sov_file"
    | "no_loss_run_file"
    | "far_away_effective_date"
    | "low_tiv"
    | "prior_submission"
    | "missing_cope_info";
};

export type appetite_result =
  | "in_appetite"
  | "sic_codes_invalid"
  | "no_sov_file"
  | "no_loss_run_file"
  | "far_away_effective_date"
  | "low_tiv"
  | "prior_submission"
  | "missing_cope_info";

export const appetite_result = {
  IN_APPETITE: "in_appetite",
  SIC_CODES_INVALID: "sic_codes_invalid",
  NO_SOV_FILE: "no_sov_file",
  NO_LOSS_RUN_FILE: "no_loss_run_file",
  FAR_AWAY_EFFECTIVE_DATE: "far_away_effective_date",
  LOW_TIV: "low_tiv",
  PRIOR_SUBMISSION: "prior_submission",
  MISSING_COPE_INFO: "missing_cope_info",
} as const;

export type Attachment = {
  name: string;
  from_email: boolean;
  original_mapping:
    | "sov_spreadsheet"
    | "acord_app"
    | "loss_run"
    | "none"
    | "screenshot"
    | "allied_policy"
    | "rater"
    | "loss_control_report"
    | "policy_document"
    | "specs_sheet"
    | "record_keeping";
  manual_mapping:
    | "sov_spreadsheet"
    | "acord_app"
    | "loss_run"
    | "none"
    | "screenshot"
    | "allied_policy"
    | "rater"
    | "loss_control_report"
    | "policy_document"
    | "specs_sheet"
    | "record_keeping"
    | null;
  source?: "email" | "screenshot_tool" | "user_upload" | null;
};

export type original_mapping =
  | "sov_spreadsheet"
  | "acord_app"
  | "loss_run"
  | "none"
  | "screenshot"
  | "allied_policy"
  | "rater"
  | "loss_control_report"
  | "policy_document"
  | "specs_sheet"
  | "record_keeping";

export const original_mapping = {
  SOV_SPREADSHEET: "sov_spreadsheet",
  ACORD_APP: "acord_app",
  LOSS_RUN: "loss_run",
  NONE: "none",
  SCREENSHOT: "screenshot",
  ALLIED_POLICY: "allied_policy",
  RATER: "rater",
  LOSS_CONTROL_REPORT: "loss_control_report",
  POLICY_DOCUMENT: "policy_document",
  SPECS_SHEET: "specs_sheet",
  RECORD_KEEPING: "record_keeping",
} as const;

export type AttachmentInfo = {
  attachments: Array<Attachment>;
};

export type AutoAssignmentStyle = {
  assignment_type: "round_robin" | "override_in_email";
  original_assignee: string;
};

export type assignment_type = "round_robin" | "override_in_email";

export const assignment_type = {
  ROUND_ROBIN: "round_robin",
  OVERRIDE_IN_EMAIL: "override_in_email",
} as const;

export type BodyAsgardCreateTemplateAsgardCreateTemplatePost = {
  template: Blob | File;
};

export type BodyAsgardGenerateDocumenntAsgardGenerateDocumentPost = {
  rater: Blob | File;
};

export type BodyAsgardUploadAdditionalFileAsgardUploadAdditionalFilesPost = {
  files: Array<Blob | File>;
};

export type BodyAsgardUploadEmlsAsgardUploadEmlsPost = {
  files: Array<Blob | File>;
};

export type BodyLoginLoginPost = {
  grant_type?: string | null;
  username: string;
  password: string;
  scope?: string;
  client_id?: string | null;
  client_secret?: string | null;
};

export type BulkEditRequest = {
  report_id: string;
  field: string;
  instructions: string;
};

export type BulkEditResponse = {
  before: Array<Address>;
  after: Array<Address>;
};

export type CalculatePremiumRequest = {
  report_id: string;
  batch_id?: string | null;
};

export type CalculatedPremiumResponse = {
  layers: Array<LayerPremiumBreakdown>;
  errors?: Array<PremiumError>;
};

export type CancelJobRequest = {
  report_integration_id: string;
};

export type CancelJobResponse = unknown;

export type CatAggregateData = {
  aal_combined?: number | null;
  aal_combined_groundup?: number | null;
  aal_per_peril?: {
    [key: string]: number;
  };
  aal_per_peril_groundup?: {
    [key: string]: number;
  };
  layers?: Array<CatLayerResult>;
  ep_curves?: Array<EpRow>;
  standard_deviation_combined?: number | null;
  standard_deviation_combined_groundup?: number | null;
  standard_deviation_per_peril?: {
    [key: string]: number;
  };
  standard_deviation_per_peril_groundup?: {
    [key: string]: number;
  };
};

export type CatIcmResults = {
  air?: CatSourceData | null;
  rms?: CatSourceData | null;
};

export type CatJobHistoryItem = {
  type: "icm" | "rms";
  batch_id: string;
  status: WorkStatus;
  started_at: string;
  finished_at: string | null;
  num_addresses?: number;
  total_aal?: number | null;
  total_tiv?: number | null;
  num_layers?: number;
  is_test?: boolean;
  sub_tasks_count?: number;
  sub_tasks_completed?: number;
};

export type type = "icm" | "rms";

export const type = {
  ICM: "icm",
  RMS: "rms",
} as const;

export type CatJobHistoryResponse = {
  jobs?: Array<CatJobHistoryItem>;
};

export type CatLayerResult = {
  layer_guid: string;
  perils?: {
    [key: string]: CatPerilLayerData;
  };
  totals?: CatPerilLayerData;
  ep_curves?: Array<EpRow>;
  locations?: Array<CatLocationWithAddress>;
};

export type CatLocationWithAddress = {
  aal_combined?: number | null;
  aal_per_peril?: {
    [key: string]: number;
  };
  address?: LocationAddress | null;
};

export type CatPerilLayerData = {
  aal?: number | null;
  pml_per_period?: {
    [key: string]: number;
  };
};

export type CatResultsResponse = {
  icm?: CatIcmResults | null;
  rms?: CatSourceData | null;
};

/**
 * Aggregate + location results for one modeling source.
 */
export type CatSourceData = {
  aggregate?: CatAggregateData | null;
  locations?: Array<CatLocationWithAddress>;
};

export type Chart = {
  title: string;
  data: Array<DataPoint>;
};

export type ChartGroup = {
  title: string;
  charts: Array<Chart>;
};

export type ClearanceEmailRecipientsRequest = {
  report_id: string;
};

export type ClearanceEmailRecipientsResponse = {
  recipients: Array<string>;
};

export type Comment = {
  message: string;
  created_at_ts: string;
  last_updated_ts: string;
  user_id: string;
  id: string;
};

export type Comments = {
  all_comments: Array<Comment>;
};

export type CommercialReport = {
  report_id: string;
  naics_info: NaicsInfo;
  sovs: Array<Sov>;
  loss_run: LossRunInfo;
  company_info: CompanyInfo;
  layer_info: Array<Layer>;
  ofac_result?: OfacResult | null;
  policy_info?: PolicyInfo | null;
  policy_questions?: {
    [key: string]: Array<PolicyQuestion>;
  } | null;
  additional_files_used?: Array<string> | null;
  loss_control_reports?: Array<LossControlReport> | null;
  attachment_info?: AttachmentInfo | null;
  referral_text?: ReferralText | null;
  policy_questions_for_policy_documents?: PolicyQuestionsForDocuments | null;
  limit_and_sublimit_info?: LimitAndSublimitInfo | null;
  limit_info?: AdvancedLimitInfo | null;
  sublimit_info?: SublimitInfo | null;
  deductible_info?: AdvancedDeductibleInfo | null;
  submission_recipients?: Array<string> | null;
  policy_fly_url?: string | null;
  policy_fly_info?: PolicyFlyInfo | null;
  email_threads?: {
    [key: string]: string;
  } | null;
};

export type CommericalReportMetadata = {
  report_id: string;
  lob: string;
  naics_info: NaicsInfo;
  company_info: CompanyInfo;
  precomputed_metadata: PrecomputedMetadata;
};

export type CompanyInfo = {
  private_computed_values: RawCompanyInfo;
  private_original_values: {
    [key: string]: Array<string> | string | null;
  };
  private_overrides: {
    [key: string]: string | Array<string> | number | null;
  };
  private_flags: {
    [key: string]: Array<
      | "low_confidence"
      | "medium_confidence"
      | "modified_by_sanitization"
      | "default_used"
      | "could_not_sanitize"
      | "po_box_insured_address"
      | YearIncorporatedDerivedFromSearch
      | MultipleCompanyNamesFlag
    >;
  };
  additional_interests?: Array<OverrideableListElementRawAdditionalInterestLiteralTodo> | null;
};

export type ComputedLossRunByYear = {
  policy_year: string;
  description_of_losses: string;
  calc_mode: "historical" | "as_if" | null;
  source_details: SourceDetails;
  source: "computed_from_claims";
  claims: Array<ParsedLoss | UserGeneratedLoss>;
};

/**
 * Contact type enum for categorizing contacts.
 */
export type ContactType = "broker";

/**
 * Contact type enum for categorizing contacts.
 */
export const ContactType = {
  BROKER: "broker",
} as const;

export type CoverageComputedFromColumnSum = {
  flag_id: "coverage_computed_from_column_sum";
  columns: Array<string>;
};

/**
 * Request body for creating a contact.
 */
export type CreateContactRequest = {
  email: string;
  contact_type: ContactType;
  full_name: string | null;
  organization_name?: string | null;
  office_phone?: string | null;
  cell_phone?: string | null;
  role?: string | null;
};

export type CreateContactResponse = {
  contact: ReportContact;
};

export type DataPoint = {
  label: string;
  value: number;
  color_code:
    | "green"
    | "yellow"
    | "red"
    | "blue"
    | "purple"
    | "teal"
    | "gray"
    | "orange"
    | "pink"
    | "indigo"
    | "cyan"
    | "lime";
  type: "percentage" | "monetary" | "count";
};

export type color_code =
  | "green"
  | "yellow"
  | "red"
  | "blue"
  | "purple"
  | "teal"
  | "gray"
  | "orange"
  | "pink"
  | "indigo"
  | "cyan"
  | "lime";

export const color_code = {
  GREEN: "green",
  YELLOW: "yellow",
  RED: "red",
  BLUE: "blue",
  PURPLE: "purple",
  TEAL: "teal",
  GRAY: "gray",
  ORANGE: "orange",
  PINK: "pink",
  INDIGO: "indigo",
  CYAN: "cyan",
  LIME: "lime",
} as const;

export type type2 = "percentage" | "monetary" | "count";

export const type2 = {
  PERCENTAGE: "percentage",
  MONETARY: "monetary",
  COUNT: "count",
} as const;

export type DeductibleEntry = {
  name: string;
  description: string;
};

export type DeleteAdditionalFilesRequest = {
  files: Array<string>;
};

export type DeleteAdditionalFilesResponse = {
  files: Array<string>;
};

export type DeleteReportRequest = {
  report_id: string;
};

export type DeleteReportResponse = unknown;

export type DeleteSavedFilterRequest = {
  id: string;
};

export type DeleteTemplate = {
  template_id: string;
};

export type Download360ReportRequest = {
  valuation_id: string;
};

export type DownloadAdditionalFileRequest = {
  report_id: string;
  file: string;
};

export type DownloadLossRunRequest = {
  loss_run_years: Array<UserGeneratedLossRunByYear>;
};

export type DownloadReportFileRequest = {
  report_id: string;
  filename: string;
};

export type DownloadReportHistoryRequest = {
  report_ids: Array<string>;
  download_type: "account" | "simple_location" | "complex_location";
};

export type download_type = "account" | "simple_location" | "complex_location";

export const download_type = {
  ACCOUNT: "account",
  SIMPLE_LOCATION: "simple_location",
  COMPLEX_LOCATION: "complex_location",
} as const;

export type DownloadTemplateRequest = {
  template_id: string;
};

export type EpRow = {
  perspective: string;
  metric_type: string;
  return_period_values?: {
    [key: string]: number;
  };
};

export type EmailThread = {
  thread_url: string;
  messages: Array<EmailThreadMessage>;
};

export type EmailThreadMessage = {
  from?: string;
  to?: string;
  cc?: string;
  subject?: string;
  date?: string;
  body_text?: string;
  body_html?: string;
};

export type EmailThreadsResponse = {
  threads: Array<EmailThread>;
};

export type EmlPreviewRequest = {
  report_id: string;
};

export type EmlPreviewResponse = {
  subject: string;
  eml: string;
};

export type GeneratePolicyFlyApplicationRequest = {
  report_id: string;
  perils_by_layer: {
    [key: string]: string;
  };
};

export type GeneratePolicyFlyApplicationResponse = {
  task_ids: Array<string>;
};

export type GeneratePolicyNumbersRequest = {
  report_id: string;
};

export type GenerateQuoteIndicationRequest = {
  report_id: string;
  perils_insured: string;
  limit_of_liability: string;
  deductibles: Array<DeductibleEntry>;
  premium_range: string;
};

export type GenerateUnderwritingPdfRequest = {
  report_id: string;
  html_content: string;
};

export type GeneratedPolicyNumbers = {
  numbers: {
    [key: string]: string | null;
  };
};

export type GetAllSovPivotsRequest = {
  report_id: string;
};

export type GetAllSovPivotsResponse = {
  all_pivots: AllPivotsResult;
};

export type GetBrokerAnalyticsResponse = {
  chart_groups: Array<ChartGroup>;
};

export type GetReportActionLogRequest = {
  report_id?: string | null;
  email_message_id?: string | null;
};

export type GetReportActionLogResponse = {
  company_name?: string | null;
  email_subject?: string | null;
  actions: Array<ReportActionLogEntryResponse>;
};

export type GetSovOverviewRequest = {
  report_id: string;
};

export type GetSovOverviewResponse = {
  sov_overview: SovOverview;
};

export type GmailDraftResponse = {
  draft_url: string;
};

export type GoogleGroupStats = {
  google_group_email: string;
  total_submissions: number;
  quote_rate: number;
  bind_rate: number;
  avg_tiv: number;
};

export type GoogleGroupStatsRequest = {
  google_group_email: string;
};

export type HttpValidationError = {
  detail?: Array<ValidationError>;
};

export type IngestEmailSyncRequest = {
  store_url: string;
  from_: string;
  to: string;
};

/**
 * Request body for initiating an ICM request.
 */
export type InitiateRequest = {
  report_id: string;
};

export type InitiateResponse = {
  request_id: string;
};

export type InitiateTestRequest = {
  report_id: string;
  model_mode: "air" | "rms" | "both";
  air_model_id?: "22" | "24";
  peril_codes: Array<
    | "PWH"
    | "PSH"
    | "PPH"
    | "PES"
    | "PSL"
    | "PFF"
    | "PFL"
    | "PWB"
    | "PWW"
    | "PWT"
  >;
  layer_ids: Array<string>;
  elevation_override?: string | null;
  address_limit?: number | null;
};

export type model_mode = "air" | "rms" | "both";

export const model_mode = {
  AIR: "air",
  RMS: "rms",
  BOTH: "both",
} as const;

export type air_model_id = "22" | "24";

export const air_model_id = {
  _22: "22",
  _24: "24",
} as const;

export type Layer = {
  layer_id?: string;
  starting_point: number;
  range: number;
  target: number | null;
  rated: number | null;
  participation?: number | null;
  layer_source?: "extracted" | "default" | "manual" | null;
  is_enabled?: boolean | null;
  selected_source?: "air" | "rms" | null;
  source_overrides?: {
    [key: string]: {
      [key: string]: SourceOverride;
    };
  } | null;
};

export type LayerPremiumBreakdown = {
  layer_id: string;
  peril_types: {
    [key: string]: {
      [key: string]: PerilTypePremium;
    };
  };
  totals: {
    [key: string]: LayerTotals;
  };
};

/**
 * Precomputed totals for one source strategy on one layer.
 */
export type LayerTotals = {
  layer_total: number;
  share_total: number;
  has_missing_data: boolean;
};

export type Limit = {
  limit_name:
    | "earthquake"
    | "earthmovement"
    | "flood"
    | "flood_high_hazard_sfha"
    | "windstorm_named_windstorm_hurricane"
    | "building_ordinance_coverage_a"
    | "building_ordinance_coverage_b"
    | "building_ordinance_coverage_c"
    | "building_ordinance_coverage_d"
    | "civil_or_military_authority"
    | "ingress_egress"
    | "debris_removal"
    | "service_interruption"
    | "contingent_time_element"
    | "evacuation_expense"
    | "electronic_data_and_media"
    | "expediting_expenses"
    | "fines_and_penalties"
    | "property_in_the_open"
    | "pairs_and_sets"
    | "trees_shrubs_and_plants"
    | "off_premises_storage"
    | "outdoor_property"
    | "land_improvements"
    | "spoilage_perishable_foods"
    | "piers_docks_wharfs_seawalls"
    | "property_in_course_of_construction"
    | "protection_and_preservation_of_property"
    | "professional_fees"
    | "animals_held_for_research"
    | "research_and_development"
    | "fire_brigade_and_extinguishing_expenses"
    | "soft_costs"
    | "vehicles_licensed_for_highway_use"
    | "waterway_access"
    | "extra_expense"
    | "fine_arts"
    | "land_water_contamination_and_cleanup_expense"
    | "decontamination_costs"
    | "leasehold_interest"
    | "loss_adjustment_expenses"
    | "personal_property_of_officers_and_employees"
    | "employee_tools"
    | "transit"
    | "accounts_receivable"
    | "mold_and_fungus"
    | "errors_and_omissions"
    | "miscellaneous_unnamed_locations"
    | "newly_acquired_automatic_coverage"
    | "extended_period_of_indemnity"
    | "backup_of_sewers_and_drains_sump_overflow"
    | "brands_and_labels"
    | "code_upgrade_upgrade_to_green"
    | "employee_personal_effects"
    | "exhibition_trade_show_property"
    | "freeze"
    | "leader_property"
    | "money_and_securities"
    | "off_premises_property_temporary_locations"
    | "refrigerated_property_temperature_change"
    | "sprinkler_leakage"
    | "strikes_riots_and_civil_commotion"
    | "valuable_papers_and_records"
    | "ordinary_payroll"
    | "impounded_water"
    | "land_and_water_cleanup_expense"
    | "limited_pollution"
    | "contractors_equipment"
    | "rental_value"
    | "royalties"
    | "cyber"
    | "asbestos"
    | "equipment_breakdown"
    | "consequential_loss"
    | "cancellation_of_bookings";
  limit_status: "included" | "excluded" | null;
  applicability:
    | "per_occurrence"
    | "per_occurrence_and_annual_aggregate"
    | null;
  amount: number | null;
  time_limit_days: number | null;
  mile_limitation: number | null;
  qualifying_period_hours: number | null;
  document_excerpt: string | null;
};

export type limit_name =
  | "earthquake"
  | "earthmovement"
  | "flood"
  | "flood_high_hazard_sfha"
  | "windstorm_named_windstorm_hurricane"
  | "building_ordinance_coverage_a"
  | "building_ordinance_coverage_b"
  | "building_ordinance_coverage_c"
  | "building_ordinance_coverage_d"
  | "civil_or_military_authority"
  | "ingress_egress"
  | "debris_removal"
  | "service_interruption"
  | "contingent_time_element"
  | "evacuation_expense"
  | "electronic_data_and_media"
  | "expediting_expenses"
  | "fines_and_penalties"
  | "property_in_the_open"
  | "pairs_and_sets"
  | "trees_shrubs_and_plants"
  | "off_premises_storage"
  | "outdoor_property"
  | "land_improvements"
  | "spoilage_perishable_foods"
  | "piers_docks_wharfs_seawalls"
  | "property_in_course_of_construction"
  | "protection_and_preservation_of_property"
  | "professional_fees"
  | "animals_held_for_research"
  | "research_and_development"
  | "fire_brigade_and_extinguishing_expenses"
  | "soft_costs"
  | "vehicles_licensed_for_highway_use"
  | "waterway_access"
  | "extra_expense"
  | "fine_arts"
  | "land_water_contamination_and_cleanup_expense"
  | "decontamination_costs"
  | "leasehold_interest"
  | "loss_adjustment_expenses"
  | "personal_property_of_officers_and_employees"
  | "employee_tools"
  | "transit"
  | "accounts_receivable"
  | "mold_and_fungus"
  | "errors_and_omissions"
  | "miscellaneous_unnamed_locations"
  | "newly_acquired_automatic_coverage"
  | "extended_period_of_indemnity"
  | "backup_of_sewers_and_drains_sump_overflow"
  | "brands_and_labels"
  | "code_upgrade_upgrade_to_green"
  | "employee_personal_effects"
  | "exhibition_trade_show_property"
  | "freeze"
  | "leader_property"
  | "money_and_securities"
  | "off_premises_property_temporary_locations"
  | "refrigerated_property_temperature_change"
  | "sprinkler_leakage"
  | "strikes_riots_and_civil_commotion"
  | "valuable_papers_and_records"
  | "ordinary_payroll"
  | "impounded_water"
  | "land_and_water_cleanup_expense"
  | "limited_pollution"
  | "contractors_equipment"
  | "rental_value"
  | "royalties"
  | "cyber"
  | "asbestos"
  | "equipment_breakdown"
  | "consequential_loss"
  | "cancellation_of_bookings";

export const limit_name = {
  EARTHQUAKE: "earthquake",
  EARTHMOVEMENT: "earthmovement",
  FLOOD: "flood",
  FLOOD_HIGH_HAZARD_SFHA: "flood_high_hazard_sfha",
  WINDSTORM_NAMED_WINDSTORM_HURRICANE: "windstorm_named_windstorm_hurricane",
  BUILDING_ORDINANCE_COVERAGE_A: "building_ordinance_coverage_a",
  BUILDING_ORDINANCE_COVERAGE_B: "building_ordinance_coverage_b",
  BUILDING_ORDINANCE_COVERAGE_C: "building_ordinance_coverage_c",
  BUILDING_ORDINANCE_COVERAGE_D: "building_ordinance_coverage_d",
  CIVIL_OR_MILITARY_AUTHORITY: "civil_or_military_authority",
  INGRESS_EGRESS: "ingress_egress",
  DEBRIS_REMOVAL: "debris_removal",
  SERVICE_INTERRUPTION: "service_interruption",
  CONTINGENT_TIME_ELEMENT: "contingent_time_element",
  EVACUATION_EXPENSE: "evacuation_expense",
  ELECTRONIC_DATA_AND_MEDIA: "electronic_data_and_media",
  EXPEDITING_EXPENSES: "expediting_expenses",
  FINES_AND_PENALTIES: "fines_and_penalties",
  PROPERTY_IN_THE_OPEN: "property_in_the_open",
  PAIRS_AND_SETS: "pairs_and_sets",
  TREES_SHRUBS_AND_PLANTS: "trees_shrubs_and_plants",
  OFF_PREMISES_STORAGE: "off_premises_storage",
  OUTDOOR_PROPERTY: "outdoor_property",
  LAND_IMPROVEMENTS: "land_improvements",
  SPOILAGE_PERISHABLE_FOODS: "spoilage_perishable_foods",
  PIERS_DOCKS_WHARFS_SEAWALLS: "piers_docks_wharfs_seawalls",
  PROPERTY_IN_COURSE_OF_CONSTRUCTION: "property_in_course_of_construction",
  PROTECTION_AND_PRESERVATION_OF_PROPERTY:
    "protection_and_preservation_of_property",
  PROFESSIONAL_FEES: "professional_fees",
  ANIMALS_HELD_FOR_RESEARCH: "animals_held_for_research",
  RESEARCH_AND_DEVELOPMENT: "research_and_development",
  FIRE_BRIGADE_AND_EXTINGUISHING_EXPENSES:
    "fire_brigade_and_extinguishing_expenses",
  SOFT_COSTS: "soft_costs",
  VEHICLES_LICENSED_FOR_HIGHWAY_USE: "vehicles_licensed_for_highway_use",
  WATERWAY_ACCESS: "waterway_access",
  EXTRA_EXPENSE: "extra_expense",
  FINE_ARTS: "fine_arts",
  LAND_WATER_CONTAMINATION_AND_CLEANUP_EXPENSE:
    "land_water_contamination_and_cleanup_expense",
  DECONTAMINATION_COSTS: "decontamination_costs",
  LEASEHOLD_INTEREST: "leasehold_interest",
  LOSS_ADJUSTMENT_EXPENSES: "loss_adjustment_expenses",
  PERSONAL_PROPERTY_OF_OFFICERS_AND_EMPLOYEES:
    "personal_property_of_officers_and_employees",
  EMPLOYEE_TOOLS: "employee_tools",
  TRANSIT: "transit",
  ACCOUNTS_RECEIVABLE: "accounts_receivable",
  MOLD_AND_FUNGUS: "mold_and_fungus",
  ERRORS_AND_OMISSIONS: "errors_and_omissions",
  MISCELLANEOUS_UNNAMED_LOCATIONS: "miscellaneous_unnamed_locations",
  NEWLY_ACQUIRED_AUTOMATIC_COVERAGE: "newly_acquired_automatic_coverage",
  EXTENDED_PERIOD_OF_INDEMNITY: "extended_period_of_indemnity",
  BACKUP_OF_SEWERS_AND_DRAINS_SUMP_OVERFLOW:
    "backup_of_sewers_and_drains_sump_overflow",
  BRANDS_AND_LABELS: "brands_and_labels",
  CODE_UPGRADE_UPGRADE_TO_GREEN: "code_upgrade_upgrade_to_green",
  EMPLOYEE_PERSONAL_EFFECTS: "employee_personal_effects",
  EXHIBITION_TRADE_SHOW_PROPERTY: "exhibition_trade_show_property",
  FREEZE: "freeze",
  LEADER_PROPERTY: "leader_property",
  MONEY_AND_SECURITIES: "money_and_securities",
  OFF_PREMISES_PROPERTY_TEMPORARY_LOCATIONS:
    "off_premises_property_temporary_locations",
  REFRIGERATED_PROPERTY_TEMPERATURE_CHANGE:
    "refrigerated_property_temperature_change",
  SPRINKLER_LEAKAGE: "sprinkler_leakage",
  STRIKES_RIOTS_AND_CIVIL_COMMOTION: "strikes_riots_and_civil_commotion",
  VALUABLE_PAPERS_AND_RECORDS: "valuable_papers_and_records",
  ORDINARY_PAYROLL: "ordinary_payroll",
  IMPOUNDED_WATER: "impounded_water",
  LAND_AND_WATER_CLEANUP_EXPENSE: "land_and_water_cleanup_expense",
  LIMITED_POLLUTION: "limited_pollution",
  CONTRACTORS_EQUIPMENT: "contractors_equipment",
  RENTAL_VALUE: "rental_value",
  ROYALTIES: "royalties",
  CYBER: "cyber",
  ASBESTOS: "asbestos",
  EQUIPMENT_BREAKDOWN: "equipment_breakdown",
  CONSEQUENTIAL_LOSS: "consequential_loss",
  CANCELLATION_OF_BOOKINGS: "cancellation_of_bookings",
} as const;

export type LimitAndSublimitInfo = {
  extracted_limits: {
    [key: string]: {
      [key: string]: Limit;
    };
  };
  manual_limits: {
    [key: string]: Limit;
  };
  active_filename?: string | null;
};

export type ListAdditionalFilesResponse = {
  files: Array<string>;
};

export type ListContactsResponse = {
  contacts: Array<ReportContact>;
};

export type ListReportActionLogsRequest = unknown;

export type ListReportActionLogsResponse = {
  summaries: Array<ReportActionSummaryWithName>;
};

export type ListReportJobsRequest = {
  report_ids: Array<string>;
  statuses: Array<WorkStatus>;
};

export type ListReportJobsResponse = {
  jobs: Array<ReportJobBatchEntry>;
};

export type ListReportsRequest = {
  lobs: Array<"property" | "builders_risk" | "cat" | "property_renewal">;
};

export type ListReportsResponse = {
  reports: Array<ReportMetadataResponse>;
};

export type ListSavedFiltersResponse = {
  filters: Array<SavedFilter>;
};

export type ListTemplatesResponse = {
  templates: Array<Template>;
};

export type ListUpdatingReportsRequest = {
  since: string;
};

export type ListUpdatingReportsResponse = {
  updates: Array<ReportBeingUpdated>;
};

export type ListUserResponse = {
  current_user: User;
  all_company_users: Array<User>;
};

export type LoadAddressesForMapRequest = {
  lobs: Array<string>;
};

export type LoadAddressesForMapResponse = {
  addresses: Array<SpatialKeyAddress>;
};

export type LocationAddress = {
  address_id: string;
  street_address: string;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  county?: string | null;
  tiv: number;
};

export type LogEventRequest = {
  event_name: string;
  event_properties: {
    [key: string]: string | number;
  };
};

export type LoginResponse = {
  access_token: string;
  token_type: string;
  client_id: string;
  user: User;
};

export type LossControlAnswer = {
  short_answer: string;
  long_answer: string;
};

export type LossControlReport = {
  entity_name?: string | null;
  filename: string;
  fields: {
    [key: string]: LossControlAnswer | null;
  };
};

export type LossRunInfo = {
  loss_runs_by_year: {
    [key: string]: Array<
      UserGeneratedLossRunByYear | ComputedLossRunByYear | ParsedLossRunByYear
    >;
  };
  enabled_by_source: {
    [key: string]: SourceDetailInfo;
  };
};

export type MappingInfo = {
  original_col_name: string;
  confidence: number;
};

export type MatchingReportInfo = {
  report_name: string;
  report_id: string;
  matching_addresses: Array<string>;
  created_at_ts: string;
};

export type MatchingReportsByAddresses = {
  matching_report_info: Array<MatchingReportInfo>;
};

export type MultipleCompanyNamesFlag = {
  flag_id: "multiple_company_names";
  company_names: Array<string>;
};

export type NaicsInfo = {
  code_type?: "sic" | "naics";
  code: string;
  description: string;
};

export type code_type = "sic" | "naics";

export const code_type = {
  SIC: "sic",
  NAICS: "naics",
} as const;

export type OfacHit = {
  sanction_lists: Array<string>;
  entity_description: string;
};

export type OfacResult = {
  hits: Array<OfacHit>;
};

export type OverrideableListElementRawAdditionalInterestLiteralTodo = {
  original: RawAdditionalInterest | null;
  deleted: boolean;
  inserted: RawAdditionalInterest | null;
  flags: {
    [key: string]: "todo";
  };
  overrides: {
    [key: string]: string;
  };
};

export type ParsedLoss = {
  policy_year: string;
  date_of_loss: string;
  address: string | null;
  claim_id: string | null;
  loss_id: string | null;
  status: string;
  description: string | null;
  ground_up_loss: number | null;
  deductible: number | null;
  net_incurred: number | null;
  is_cat_event: boolean | null;
  claim_type: "historical" | "as_if" | null;
  source: "parsed";
  source_details: SourceDetails;
  overrides: {
    [key: string]: string;
  };
  flags: {
    [key: string]: Array<"could_not_parse">;
  };
  original_values: {
    [key: string]: string;
  };
};

export type ParsedLossRunByYear = {
  policy_year: string;
  description_of_losses: string;
  calc_mode: "historical" | "as_if" | null;
  source_details: SourceDetails;
  source: "parsed_year";
  open_claims: number;
  closed_claims: number;
  ground_up_loss: number | null;
  net_incurred: number | null;
  carrier: string | null;
  flags: {
    [key: string]: Array<"could_not_parse">;
  };
  original_values: {
    [key: string]: string;
  };
  overrides: {
    [key: string]: string;
  };
};

export type PerilCodePremium = {
  peril_code: string;
  aal: number;
  multiplier: number | null;
  multiplier_reason: string;
  layer_premium: number;
  share_premium: number;
  missing: boolean;
  warnings: {
    [key: string]: number;
  };
};

export type PerilMultipleCategories = {
  ns: "tri_county" | "fl" | "baseline";
  ns_reason: string;
  eq: "ca" | "baseline";
  eq_reason: string;
};

export type ns = "tri_county" | "fl" | "baseline";

export const ns = {
  TRI_COUNTY: "tri_county",
  FL: "fl",
  BASELINE: "baseline",
} as const;

export type eq = "ca" | "baseline";

export const eq = {
  CA: "ca",
  BASELINE: "baseline",
} as const;

export type PerilTypePremium = {
  peril_type:
    | "aop"
    | "earthquake"
    | "earth_movement"
    | "named_storm"
    | "scs"
    | "flood"
    | "wildfire"
    | "equipment_breakdown"
    | "wind_and_hail";
  source: "air" | "rms";
  parts: Array<PerilCodePremium>;
  total_aal?: number;
  share_effective: number;
  layer_effective: number;
  multiple_effective: number | null;
  override_type: "multiple" | "premium" | null;
  override_multiple: number | null;
  override_premium: number | null;
};

export type source = "air" | "rms";

export const source = {
  AIR: "air",
  RMS: "rms",
} as const;

export type PivotRow = {
  group_value: string;
  location_count: number;
  total_tiv: number;
  percent_of_tiv: number;
};

export type PivotTableResult = {
  column_name:
    | "construction_description"
    | "occupancy_description"
    | "state"
    | "sprinkler"
    | "year_built"
    | "flood_zone"
    | "rms_dist_to_coast";
  rows: Array<PivotRow>;
  total_row: PivotRow;
};

export type column_name =
  | "construction_description"
  | "occupancy_description"
  | "state"
  | "sprinkler"
  | "year_built"
  | "flood_zone"
  | "rms_dist_to_coast";

export const column_name = {
  CONSTRUCTION_DESCRIPTION: "construction_description",
  OCCUPANCY_DESCRIPTION: "occupancy_description",
  STATE: "state",
  SPRINKLER: "sprinkler",
  YEAR_BUILT: "year_built",
  FLOOD_ZONE: "flood_zone",
  RMS_DIST_TO_COAST: "rms_dist_to_coast",
} as const;

export type PolicyFlyApplication = {
  layer_id: string;
  suffix: string;
  url?: string | null;
  request_id?: string | null;
};

export type PolicyFlyInfo = {
  applications: Array<PolicyFlyApplication>;
};

export type PolicyInfo = {
  selected_policy_form_name: string | null;
  included_perils: Array<
    | "aop"
    | "earthquake"
    | "earth_movement"
    | "named_storm"
    | "scs"
    | "flood"
    | "wildfire"
    | "equipment_breakdown"
    | "wind_and_hail"
  >;
  peril_sentence_override?: string | null;
  valuation_info?: ValuationInfo | null;
  form_selection?: "ISO" | "Co-Participation" | "Manuscript" | null;
  broker_commission_percentage?: number | null;
  edited_fields?: Array<string>;
};

export type PolicyQuestion = {
  question: string;
  short_answer: string;
  long_answer: string;
  question_id: string;
  excerpt: string;
  confidence: string;
  page_location: string;
};

export type PolicyQuestionAndAnswer = {
  id: string;
  question: string;
  answer: string;
  answer_type: "Yes" | "No" | "N/A";
  excerpt: string;
};

export type answer_type = "Yes" | "No" | "N/A";

export const answer_type = {
  YES: "Yes",
  NO: "No",
  N_A: "N/A",
} as const;

export type PolicyQuestionsForDocuments = {
  questions_by_file: Array<PolicyQuestionsForFile>;
};

export type PolicyQuestionsForFile = {
  filename: string;
  questions_by_section: Array<PolicyQuestionsForSection>;
};

export type PolicyQuestionsForSection = {
  section: string;
  questions: Array<PolicyQuestionAndAnswer>;
};

export type PrecomputedMetadata = {
  num_locations: number;
  total_tiv: number;
  unique_location_states?: Array<string> | null;
  appetite?: Appetite | null;
  matching_reports_by_addresses?: MatchingReportsByAddresses | null;
  premium_categories?: PerilMultipleCategories | null;
};

export type PremiumError = {
  code: string;
  message: string;
};

export type RateSubmissionRequest = {
  report_id: string;
  template_override_id?: string | null;
};

export type RateSubmissionResponse = {
  batch_id: string;
};

export type RawAdditionalInterest = {
  entity_name: string;
  entity_address: string;
  form_name: string;
  linked_address_id: string | null;
};

export type RawAddress = {
  street_address: string;
  tiv: number;
  state?: string | null;
  city?: string | null;
  zip?: string | null;
  county?: string | null;
  country?: string | null;
  country_scheme?: string | null;
  country_code?: string | null;
  year_built?: string | null;
  sprinkler?: string | null;
  building_value?: string | null;
  bpp_value?: string | null;
  tenant_betterments_value?: string | null;
  signs_value?: string | null;
  bi_excl_ee_value?: string | null;
  bi_incl_ee_value?: string | null;
  furniture_and_fixtures_value?: string | null;
  inventory_value?: string | null;
  contractors_equipment_value?: string | null;
  outdoor_property_and_autos_value?: string | null;
  number_of_stories?: string | null;
  construction_code_type?: string | null;
  construction_code?: string | null;
  construction_description?: string | null;
  occupancy_code_type?: string | null;
  occupancy_code?: string | null;
  occupancy_description?: string | null;
  occupancy_description_other?: string | null;
  sic_code?: string | null;
  location_name?: string | null;
  location_description?: string | null;
  lat?: string | null;
  long?: string | null;
  number_of_buildings?: string | null;
  square_footage?: string | null;
  plan_irregularity?: string | null;
  soft_story?: string | null;
  vertical_irregularity?: string | null;
  eq_cladding_type?: string | null;
  short_column?: string | null;
  urm_chimney?: string | null;
  urm_partition?: string | null;
  ornamentation?: string | null;
  cripple_walls?: string | null;
  frame_bolted_down?: string | null;
  anchoring?: string | null;
  urm_retrofit?: string | null;
  structural_upgrade?: string | null;
  engineered_foundation?: string | null;
  equipment_eq_bracing?: string | null;
  eq_construction_quality?: string | null;
  equipment_support_maintenance?: string | null;
  pounding?: string | null;
  base_isolation?: string | null;
  sprinkler_type?: string | null;
  eqsl_susceptibility?: string | null;
  ws_construction_quality?: string | null;
  roof_geometry?: string | null;
  roof_anchor?: string | null;
  roof_equipment_hurricane_bracing?: string | null;
  commercial_appurtenant_structures?: string | null;
  roof_covering?: string | null;
  roof_age_or_condition?: string | null;
  ws_cladding_type?: string | null;
  roof_sheathing_attachment?: string | null;
  frame_foundation_connection?: string | null;
  residential_appurtenant_structures?: string | null;
  ground_level_equipment?: string | null;
  opening_protection?: string | null;
  flashing_and_coping_quality?: string | null;
  floor_type?: string | null;
  flood_missiles?: string | null;
  flood_protection?: string | null;
  basement_protection?: string | null;
  vertical_exposure_distribution?: string | null;
  bi_preparedness?: string | null;
  bi_redundancy?: string | null;
  flood_zone?: string | null;
  wiring_year?: string | null;
  plumbing_year?: string | null;
  roofing_year?: string | null;
  heating_year?: string | null;
  fire_alarm_type?: string | null;
  burglar_alarm_type?: string | null;
  premises_number?: string | null;
  building_number?: string | null;
  geocoded_street_address?: string | null;
  geocoded_city?: string | null;
  geocoded_county?: string | null;
  geocoded_state?: string | null;
  geocoded_zip?: string | null;
  geocoded_country?: string | null;
};

export type RawCompanyInfo = {
  company_name: string;
  company_description: string;
  company_industry: string;
  effective_date: string;
  broker_name?: string | null;
  broker_email?: string | null;
  broker_agent_name?: string | null;
  named_insured?: string | null;
  additional_named_insureds?: Array<string> | null;
  dba?: string | null;
  entity_type?: string | null;
  expiration_date?: string | null;
  business_description?: string | null;
  years_in_business?: string | null;
  company_address?: string | null;
  company_city?: string | null;
  company_state?: string | null;
  company_zip?: string | null;
  target_premium?: string | null;
  quote_by_date?: string | null;
  year_of_incorporation?: string | null;
};

export type ReferralText = {
  text: string | null;
};

export type ReportActionLogEntryResponse = {
  id: number;
  email_message_id: string | null;
  report_id: string | null;
  user_id: string | null;
  client_id: string;
  timestamp: string;
  action_type:
    | "EMAIL_RECEIVED"
    | "REPORT_CREATED"
    | "EMAIL_ADDED_TO_REPORT"
    | "EMAIL_REJECTED_INVALID_SENDER"
    | "EMAIL_REJECTED_DUPLICATE"
    | "EMAIL_REJECTED_NO_ATTACHMENTS"
    | "EMAIL_REJECTED_REPLY_THREAD"
    | "UPDATE_REPORT"
    | "UPDATE_ADDRESSES"
    | "INTEGRATION_JOB_ENQUEUED"
    | "INTEGRATION_JOB_STARTED"
    | "INTEGRATION_JOB_COMPLETED"
    | "INTEGRATION_JOB_FAILED"
    | "CLEARANCE_EMAIL_SENT"
    | "QUOTE_INDICATION_DRAFTED"
    | "ATTACHMENT_UPLOADED"
    | "COMMENT_ADDED";
  metadata: {
    [key: string]: unknown;
  } | null;
};

export type action_type =
  | "EMAIL_RECEIVED"
  | "REPORT_CREATED"
  | "EMAIL_ADDED_TO_REPORT"
  | "EMAIL_REJECTED_INVALID_SENDER"
  | "EMAIL_REJECTED_DUPLICATE"
  | "EMAIL_REJECTED_NO_ATTACHMENTS"
  | "EMAIL_REJECTED_REPLY_THREAD"
  | "UPDATE_REPORT"
  | "UPDATE_ADDRESSES"
  | "INTEGRATION_JOB_ENQUEUED"
  | "INTEGRATION_JOB_STARTED"
  | "INTEGRATION_JOB_COMPLETED"
  | "INTEGRATION_JOB_FAILED"
  | "CLEARANCE_EMAIL_SENT"
  | "QUOTE_INDICATION_DRAFTED"
  | "ATTACHMENT_UPLOADED"
  | "COMMENT_ADDED";

export const action_type = {
  EMAIL_RECEIVED: "EMAIL_RECEIVED",
  REPORT_CREATED: "REPORT_CREATED",
  EMAIL_ADDED_TO_REPORT: "EMAIL_ADDED_TO_REPORT",
  EMAIL_REJECTED_INVALID_SENDER: "EMAIL_REJECTED_INVALID_SENDER",
  EMAIL_REJECTED_DUPLICATE: "EMAIL_REJECTED_DUPLICATE",
  EMAIL_REJECTED_NO_ATTACHMENTS: "EMAIL_REJECTED_NO_ATTACHMENTS",
  EMAIL_REJECTED_REPLY_THREAD: "EMAIL_REJECTED_REPLY_THREAD",
  UPDATE_REPORT: "UPDATE_REPORT",
  UPDATE_ADDRESSES: "UPDATE_ADDRESSES",
  INTEGRATION_JOB_ENQUEUED: "INTEGRATION_JOB_ENQUEUED",
  INTEGRATION_JOB_STARTED: "INTEGRATION_JOB_STARTED",
  INTEGRATION_JOB_COMPLETED: "INTEGRATION_JOB_COMPLETED",
  INTEGRATION_JOB_FAILED: "INTEGRATION_JOB_FAILED",
  CLEARANCE_EMAIL_SENT: "CLEARANCE_EMAIL_SENT",
  QUOTE_INDICATION_DRAFTED: "QUOTE_INDICATION_DRAFTED",
  ATTACHMENT_UPLOADED: "ATTACHMENT_UPLOADED",
  COMMENT_ADDED: "COMMENT_ADDED",
} as const;

export type ReportActionSummaryWithName = {
  report_id?: string | null;
  company_name?: string | null;
  email_message_id?: string | null;
  email_subject?: string | null;
  sender?: string | null;
  latest_action_type:
    | "EMAIL_RECEIVED"
    | "REPORT_CREATED"
    | "EMAIL_ADDED_TO_REPORT"
    | "EMAIL_REJECTED_INVALID_SENDER"
    | "EMAIL_REJECTED_DUPLICATE"
    | "EMAIL_REJECTED_NO_ATTACHMENTS"
    | "EMAIL_REJECTED_REPLY_THREAD"
    | "UPDATE_REPORT"
    | "UPDATE_ADDRESSES"
    | "INTEGRATION_JOB_ENQUEUED"
    | "INTEGRATION_JOB_STARTED"
    | "INTEGRATION_JOB_COMPLETED"
    | "INTEGRATION_JOB_FAILED"
    | "CLEARANCE_EMAIL_SENT"
    | "QUOTE_INDICATION_DRAFTED"
    | "ATTACHMENT_UPLOADED"
    | "COMMENT_ADDED";
  latest_timestamp: string;
  action_count: number;
};

export type latest_action_type =
  | "EMAIL_RECEIVED"
  | "REPORT_CREATED"
  | "EMAIL_ADDED_TO_REPORT"
  | "EMAIL_REJECTED_INVALID_SENDER"
  | "EMAIL_REJECTED_DUPLICATE"
  | "EMAIL_REJECTED_NO_ATTACHMENTS"
  | "EMAIL_REJECTED_REPLY_THREAD"
  | "UPDATE_REPORT"
  | "UPDATE_ADDRESSES"
  | "INTEGRATION_JOB_ENQUEUED"
  | "INTEGRATION_JOB_STARTED"
  | "INTEGRATION_JOB_COMPLETED"
  | "INTEGRATION_JOB_FAILED"
  | "CLEARANCE_EMAIL_SENT"
  | "QUOTE_INDICATION_DRAFTED"
  | "ATTACHMENT_UPLOADED"
  | "COMMENT_ADDED";

export const latest_action_type = {
  EMAIL_RECEIVED: "EMAIL_RECEIVED",
  REPORT_CREATED: "REPORT_CREATED",
  EMAIL_ADDED_TO_REPORT: "EMAIL_ADDED_TO_REPORT",
  EMAIL_REJECTED_INVALID_SENDER: "EMAIL_REJECTED_INVALID_SENDER",
  EMAIL_REJECTED_DUPLICATE: "EMAIL_REJECTED_DUPLICATE",
  EMAIL_REJECTED_NO_ATTACHMENTS: "EMAIL_REJECTED_NO_ATTACHMENTS",
  EMAIL_REJECTED_REPLY_THREAD: "EMAIL_REJECTED_REPLY_THREAD",
  UPDATE_REPORT: "UPDATE_REPORT",
  UPDATE_ADDRESSES: "UPDATE_ADDRESSES",
  INTEGRATION_JOB_ENQUEUED: "INTEGRATION_JOB_ENQUEUED",
  INTEGRATION_JOB_STARTED: "INTEGRATION_JOB_STARTED",
  INTEGRATION_JOB_COMPLETED: "INTEGRATION_JOB_COMPLETED",
  INTEGRATION_JOB_FAILED: "INTEGRATION_JOB_FAILED",
  CLEARANCE_EMAIL_SENT: "CLEARANCE_EMAIL_SENT",
  QUOTE_INDICATION_DRAFTED: "QUOTE_INDICATION_DRAFTED",
  ATTACHMENT_UPLOADED: "ATTACHMENT_UPLOADED",
  COMMENT_ADDED: "COMMENT_ADDED",
} as const;

export type ReportBeingUpdated = {
  update_id: string;
  report_id: string;
  running_user_id: string | null;
  start_time: string;
  outcome: "success" | "failure" | null;
  integration_type: string;
  policy_fly_url?: string | null;
};

export type ReportContact = {
  id: string;
  contact_type: ContactType;
  email: string;
  organization_name: string | null;
  full_name: string | null;
  office_phone: string | null;
  cell_phone: string | null;
  role: string | null;
};

export type ReportJobBatchEntry = {
  batch_id: string;
  report_id: string;
  integration_type: string;
  outcome: "success" | "failure" | null;
  started_at: string;
  finished_at: string | null;
  responses: Array<{
    [key: string]: unknown;
  } | null>;
  queue_positions: Array<number | null>;
};

export type ReportMetadataResponse = {
  report_id: string;
  lob: string;
  report_metadata: CommericalReportMetadata;
  comments: Comments;
  created_at_ts: string;
  modified_at_ts: string;
  assignee: string | null;
  status:
    | "pre_underwriting_review"
    | "not_cleared_prior_submission"
    | "not_cleared_incomplete_submission"
    | "not_cleared_out_of_appetite"
    | "not_cleared_effective_date_too_far"
    | "not_cleared_unapproved_broker"
    | "not_cleared_low_tiv"
    | "cleared"
    | "pending"
    | "indicated"
    | "quoted"
    | "declined"
    | "lost"
    | "bound"
    | "issued";
  additional_assignees: AdditionalAssigneeInfo | null;
  broker_contact: ReportContact | null;
  google_group_email: string | null;
};

export type status =
  | "pre_underwriting_review"
  | "not_cleared_prior_submission"
  | "not_cleared_incomplete_submission"
  | "not_cleared_out_of_appetite"
  | "not_cleared_effective_date_too_far"
  | "not_cleared_unapproved_broker"
  | "not_cleared_low_tiv"
  | "cleared"
  | "pending"
  | "indicated"
  | "quoted"
  | "declined"
  | "lost"
  | "bound"
  | "issued";

export const status = {
  PRE_UNDERWRITING_REVIEW: "pre_underwriting_review",
  NOT_CLEARED_PRIOR_SUBMISSION: "not_cleared_prior_submission",
  NOT_CLEARED_INCOMPLETE_SUBMISSION: "not_cleared_incomplete_submission",
  NOT_CLEARED_OUT_OF_APPETITE: "not_cleared_out_of_appetite",
  NOT_CLEARED_EFFECTIVE_DATE_TOO_FAR: "not_cleared_effective_date_too_far",
  NOT_CLEARED_UNAPPROVED_BROKER: "not_cleared_unapproved_broker",
  NOT_CLEARED_LOW_TIV: "not_cleared_low_tiv",
  CLEARED: "cleared",
  PENDING: "pending",
  INDICATED: "indicated",
  QUOTED: "quoted",
  DECLINED: "declined",
  LOST: "lost",
  BOUND: "bound",
  ISSUED: "issued",
} as const;

export type ReportResponse = {
  report_id: string;
  policy_number: string | null;
  lob: string;
  email_subject: string;
  report_json: CommercialReport;
  created_at_ts: string;
  modified_at_ts: string;
  review_info: ReviewInfo;
  assignee: string | null;
  status:
    | "pre_underwriting_review"
    | "not_cleared_prior_submission"
    | "not_cleared_incomplete_submission"
    | "not_cleared_out_of_appetite"
    | "not_cleared_effective_date_too_far"
    | "not_cleared_unapproved_broker"
    | "not_cleared_low_tiv"
    | "cleared"
    | "pending"
    | "indicated"
    | "quoted"
    | "declined"
    | "lost"
    | "bound"
    | "issued";
  additional_assignees: AdditionalAssigneeInfo | null;
  precomputed_metadata: PrecomputedMetadata;
  comments: Comments;
  auto_assignment_style: AutoAssignmentStyle | null;
  broker_contact: ReportContact | null;
  google_group_email: string | null;
};

export type ReviewInfo = {
  responses?: {
    [key: string]: ReviewQuestionResponse;
  };
};

export type ReviewQuestionResponse = {
  question_id: string;
  status: string;
  warning_message?: string | null;
  last_updated_ts?: string | null;
  last_updated_user_id?: string | null;
};

export type RmsInitiateRequest = {
  report_id: string;
  layer_ids?: Array<string> | null;
  max_location_override?: boolean;
};

export type RmsInitiateResponse = {
  request_id: string;
};

export type RmsStatusResponse = {
  is_complete: boolean;
  status: WorkStatus;
};

export type Sov = {
  sov_id: string;
  addresses: Array<Address>;
  is_enabled: boolean;
  is_manual?: boolean;
  filename: string;
  all_document_headers?: Array<string> | null;
  column_mappings?: {
    [key: string]: MappingInfo;
  } | null;
  column_overrides?: {
    [key: string]: string;
  } | null;
  tiv_totals_match_on_ingest?: boolean | null;
  reconciliation_function?: string | null;
  tiv_reconciliation_explanation?: string | null;
};

export type SavedFilter = {
  id: string;
  url: string;
  nickname: string;
  is_default: boolean;
};

export type SearchAddressRequest = {
  lobs: Array<string>;
  raw_query: string | null;
  term_query: Array<TermSearch> | null;
};

export type SearchAddressResponse = {
  by_report: {
    [key: string]: Array<Address>;
  };
  term_query: Array<TermSearch> | null;
};

export type SendClearanceEmailRequest = {
  report_id: string;
  status:
    | "pre_underwriting_review"
    | "not_cleared_prior_submission"
    | "not_cleared_incomplete_submission"
    | "not_cleared_out_of_appetite"
    | "not_cleared_effective_date_too_far"
    | "not_cleared_unapproved_broker"
    | "not_cleared_low_tiv"
    | "cleared"
    | "pending"
    | "indicated"
    | "quoted"
    | "declined"
    | "lost"
    | "bound"
    | "issued";
};

export type SourceDetailInfo = {
  source_details: SourceDetails;
  enabled: boolean;
};

export type SourceDetails = {
  filename: string;
  sheet_name: string | null;
  data_type: "claim" | "summary";
  calc_mode: "historical" | "as_if" | null;
  carrier: string | null;
};

export type data_type = "claim" | "summary";

export const data_type = {
  CLAIM: "claim",
  SUMMARY: "summary",
} as const;

/**
 * Override for a single peril within a single source.
 *
 * Exactly one of multiple or premium should be set.
 * When multiple is set: effective_premium = AAL * multiple.
 * When premium is set: effective_multiple = premium / AAL.
 */
export type SourceOverride = {
  multiple?: number | null;
  premium?: number | null;
};

export type SovOverview = {
  chart_groups: Array<ChartGroup>;
};

export type SpatialKeyAddress = {
  "Policy Number": string;
  "Named Insured": string;
  "Effective Date": string;
  "Expiration Date": string;
  "Location #"?: string | null;
  "Bulding#"?: string | null;
  "Street 1"?: string | null;
  "Street 2"?: string | null;
  City?: string | null;
  State?: string | null;
  Zip?: string | null;
  County?: string | null;
  BLDG?: number | null;
  BPP?: number | null;
  BI_EE?: number | null;
  BI?: number | null;
  TIB?: number | null;
  SIGNS?: number | null;
  FF?: number | null;
  INV?: number | null;
  CE?: number | null;
  OPA?: number | null;
  "Total TIV"?: number | null;
  EQPBK?: string | null;
  TRIA?: string | null;
  LNLawOrdA?: number | null;
  LNLawOrdBC?: number | null;
  LNLawOrd?: number | null;
  Valuation?: string | null;
  Coinsurance?: string | null;
  PTY_WIND_INCL_Y_N?: string | null;
  WIND_DEDUCTIBLE_BASIS?: string | null;
  WIND_DEDUCTIBLE_AMOUNT?: string | null;
  WIND_DEDUCTIBLE_PERCENTAGE?: string | null;
  AOP_DEDUCTIBLE_BASIS?: string | null;
  AOP_DEDUCTIBLE_PERCENTAGE?: string | null;
  AOP_DEDUCTIBLE_AMOUNT?: string | null;
  CP_DEDUCTIBLE_AMOUNT?: string | null;
  CP_DEDUCTIBLE_TYPE?: string | null;
  "Latitude(SK)"?: number | null;
  "Longitude(SK)"?: number | null;
  "Geocoding Accuracy"?: string | null;
};

export type StatusResponse = {
  is_complete: boolean;
  status: WorkStatus;
};

export type Sublimit = {
  sublimit_name: string;
  sublimit_description: string;
  document_excerpt: string | null;
  manual_override?: string | null;
  is_removed?: boolean | null;
  classification?: "time_limit" | "distance_limit" | "waiting_period" | null;
};

export type SublimitInfo = {
  extracted_sublimits: {
    [key: string]: Array<Sublimit>;
  };
  manual_sublimits: Array<Sublimit>;
};

export type Template = {
  template_id: string;
  client_id: string;
  author_id: string;
  use_case: string;
  created_at_ts: string;
  template_pointer: string;
  template_name: string;
  live: true | null;
};

export type TermSearch = {
  street?: string | null;
  state?: string | null;
  city?: string | null;
  zip?: string | null;
};

export type TestPythonFunctionRequest = {
  peril_type:
    | "aop"
    | "earthquake"
    | "earth_movement"
    | "named_storm"
    | "scs"
    | "flood"
    | "wildfire"
    | "equipment_breakdown";
  extracted_filename?: string | null;
  function_type: "limit" | "deductible";
};

export type peril_type =
  | "aop"
  | "earthquake"
  | "earth_movement"
  | "named_storm"
  | "scs"
  | "flood"
  | "wildfire"
  | "equipment_breakdown";

export const peril_type = {
  AOP: "aop",
  EARTHQUAKE: "earthquake",
  EARTH_MOVEMENT: "earth_movement",
  NAMED_STORM: "named_storm",
  SCS: "scs",
  FLOOD: "flood",
  WILDFIRE: "wildfire",
  EQUIPMENT_BREAKDOWN: "equipment_breakdown",
} as const;

export type function_type = "limit" | "deductible";

export const function_type = {
  LIMIT: "limit",
  DEDUCTIBLE: "deductible",
} as const;

export type TestPythonFunctionResponse = {
  num_addresses_run: number;
};

export type UnknownCoverageColumnFlag = {
  flag_id: "unkonwn_coverage_column";
  columns: Array<string>;
};

export type UnknownInsuranceSubjectFlag = {
  flag_id: "non_property_insurance_value_v2";
  subjects: Array<string>;
};

export type UpdateAddressRequest = {
  report_id: string;
  addresses: Array<Address>;
};

export type UpdateAddressResponse = {
  addresses: Array<Address>;
};

export type UpdateAsignee = {
  new_assignee: string | null;
};

export type UpdateBrokerContact = {
  new_broker_contact_id: string;
};

export type UpdateContactRequest = {
  full_name?: string | null;
  organization_name?: string | null;
  office_phone?: string | null;
  cell_phone?: string | null;
  role?: string | null;
};

export type UpdateContactResponse = {
  contact: ReportContact;
};

export type UpdateReportRequest = {
  report_id: string;
  update_assignee: UpdateAsignee | null;
  update_status: UpdateStatus | null;
  update_additional_assignees: AdditionalAssigneeInfo | null;
  update_sovs: Array<Sov> | null;
  update_loss_runs_info: LossRunInfo | null;
  update_review_question_response: ReviewQuestionResponse | null;
  update_company_info: CompanyInfo | null;
  update_attachment_info: AttachmentInfo | null;
  update_referral_text: ReferralText | null;
  rerun_report: boolean | null;
  update_broker_contact: UpdateBrokerContact | null;
  update_limit_info: LimitAndSublimitInfo | null;
  update_policy_info: PolicyInfo | null;
  update_sublimit_info: SublimitInfo | null;
  update_deductible_info: AdvancedDeductibleInfo | null;
  update_advanced_limit_info: AdvancedLimitInfo | null;
  update_layer_info: Array<Layer> | null;
};

export type UpdateReportResponse = {
  report: ReportResponse;
};

export type UpdateSavedFilterRequest = {
  id: string;
  is_default: boolean;
  nickname: string;
};

export type UpdateStatus = {
  new_status:
    | "pre_underwriting_review"
    | "not_cleared_prior_submission"
    | "not_cleared_incomplete_submission"
    | "not_cleared_out_of_appetite"
    | "not_cleared_effective_date_too_far"
    | "not_cleared_unapproved_broker"
    | "not_cleared_low_tiv"
    | "cleared"
    | "pending"
    | "indicated"
    | "quoted"
    | "declined"
    | "lost"
    | "bound"
    | "issued";
};

export type new_status =
  | "pre_underwriting_review"
  | "not_cleared_prior_submission"
  | "not_cleared_incomplete_submission"
  | "not_cleared_out_of_appetite"
  | "not_cleared_effective_date_too_far"
  | "not_cleared_unapproved_broker"
  | "not_cleared_low_tiv"
  | "cleared"
  | "pending"
  | "indicated"
  | "quoted"
  | "declined"
  | "lost"
  | "bound"
  | "issued";

export const new_status = {
  PRE_UNDERWRITING_REVIEW: "pre_underwriting_review",
  NOT_CLEARED_PRIOR_SUBMISSION: "not_cleared_prior_submission",
  NOT_CLEARED_INCOMPLETE_SUBMISSION: "not_cleared_incomplete_submission",
  NOT_CLEARED_OUT_OF_APPETITE: "not_cleared_out_of_appetite",
  NOT_CLEARED_EFFECTIVE_DATE_TOO_FAR: "not_cleared_effective_date_too_far",
  NOT_CLEARED_UNAPPROVED_BROKER: "not_cleared_unapproved_broker",
  NOT_CLEARED_LOW_TIV: "not_cleared_low_tiv",
  CLEARED: "cleared",
  PENDING: "pending",
  INDICATED: "indicated",
  QUOTED: "quoted",
  DECLINED: "declined",
  LOST: "lost",
  BOUND: "bound",
  ISSUED: "issued",
} as const;

export type UpdateTemplate = {
  template_id: string;
  live: boolean;
};

export type UploadAdditionalFilesResponse = {
  files: Array<string>;
};

export type User = {
  id: string;
  email: string;
  client_id: string;
  lobs: Array<string>;
  full_name?: string | null;
  is_client_admin: boolean;
};

export type UserGeneratedLoss = {
  policy_year: string;
  date_of_loss: string;
  address: string | null;
  claim_id: string | null;
  loss_id: string | null;
  status: string;
  description: string | null;
  ground_up_loss: number | null;
  deductible: number | null;
  net_incurred: number | null;
  is_cat_event: boolean | null;
  claim_type: "historical" | "as_if" | null;
  source: "user_generated";
  source_details: SourceDetails;
};

export type UserGeneratedLossRunByYear = {
  policy_year: string;
  description_of_losses: string;
  calc_mode: "historical" | "as_if" | null;
  source_details: SourceDetails;
  open_claims: number;
  closed_claims: number;
  ground_up_loss: number | null;
  net_incurred: number | null;
  source: "user_generated";
};

export type ValidationError = {
  loc: Array<string | number>;
  msg: string;
  type: string;
};

export type ValuationInfo = {
  physical_valuation_type_1:
    | "Excluded"
    | "Actual Cash Value"
    | "Replacement Cost"
    | "Functional Replacement Cost"
    | "Selling Price"
    | "Actual Loss Sustained"
    | "Agreed Value"
    | "Actual Cash Value, except Replacement cost if newer than 5 years old"
    | null;
  physical_valuation_type_2:
    | "Excluded"
    | "Actual Cash Value"
    | "Replacement Cost"
    | "Functional Replacement Cost"
    | "Selling Price"
    | "Actual Loss Sustained"
    | "Agreed Value"
    | "Actual Cash Value, except Replacement cost if newer than 5 years old"
    | null;
  bi_valuation_type:
    | "Excluded"
    | "Actual Cash Value"
    | "Replacement Cost"
    | "Functional Replacement Cost"
    | "Selling Price"
    | "Actual Loss Sustained"
    | "Agreed Value"
    | "Actual Cash Value, except Replacement cost if newer than 5 years old"
    | null;
  equipment_valuation_type:
    | "Excluded"
    | "Actual Cash Value"
    | "Replacement Cost"
    | "Functional Replacement Cost"
    | "Selling Price"
    | "Actual Loss Sustained"
    | "Agreed Value"
    | "Actual Cash Value, except Replacement cost if newer than 5 years old"
    | null;
};

/**
 * Status of a queued job.
 */
export type WorkStatus =
  | "pending"
  | "in_progress"
  | "done"
  | "failed"
  | "cancelled";

/**
 * Status of a queued job.
 */
export const WorkStatus = {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  DONE: "done",
  FAILED: "failed",
  CANCELLED: "cancelled",
} as const;

export type YearIncorporatedDerivedFromSearch = {
  flag_id: "year_incorporated_derived_from_search";
  source: string;
};

export type ListContactsEndpointCrmContactsGetResponse = ListContactsResponse;

export type CreateContactEndpointCrmContactPostData = {
  requestBody: CreateContactRequest;
};

export type CreateContactEndpointCrmContactPostResponse = CreateContactResponse;

export type UpdateContactEndpointCrmContactContactIdPostData = {
  contactId: string;
  requestBody: UpdateContactRequest;
};

export type UpdateContactEndpointCrmContactContactIdPostResponse =
  UpdateContactResponse;

export type BrokerAnalyticsCrmBrokerAnalyticsGetData = {
  dateChoice: "current_month" | "last_month" | "past_year" | "year_to_date";
  reportSelection: "created" | "brokerage_bind_rate" | "brokerage_quoted_rate";
};

export type BrokerAnalyticsCrmBrokerAnalyticsGetResponse =
  GetBrokerAnalyticsResponse;

export type CrmBrokerExportCrmBrokerExportPostResponse = unknown;

export type AsgardListReportActionLogsAsgardListReportActionLogsPostData = {
  requestBody: ListReportActionLogsRequest;
};

export type AsgardListReportActionLogsAsgardListReportActionLogsPostResponse =
  ListReportActionLogsResponse;

export type AsgardGetReportActionLogAsgardGetReportActionLogPostData = {
  requestBody: GetReportActionLogRequest;
};

export type AsgardGetReportActionLogAsgardGetReportActionLogPostResponse =
  GetReportActionLogResponse;

export type InitiateRequestEndpointIcmInitiatePostData = {
  requestBody: InitiateRequest;
};

export type InitiateRequestEndpointIcmInitiatePostResponse = InitiateResponse;

export type InitiateTestRequestEndpointIcmInitiateTestPostData = {
  requestBody: InitiateTestRequest;
};

export type InitiateTestRequestEndpointIcmInitiateTestPostResponse =
  InitiateResponse;

export type RequestStatusIcmStatusRequestIdGetData = {
  requestId: string;
};

export type RequestStatusIcmStatusRequestIdGetResponse = StatusResponse;

export type InitiateRmsRequestRmsInitiatePostData = {
  requestBody: RmsInitiateRequest;
};

export type InitiateRmsRequestRmsInitiatePostResponse = RmsInitiateResponse;

export type RmsRequestStatusRmsStatusRequestIdGetData = {
  requestId: string;
};

export type RmsRequestStatusRmsStatusRequestIdGetResponse = RmsStatusResponse;

export type DownloadCatArtifactCatDownloadReportIdBatchIdGetData = {
  /**
   * Artifact prefix to download
   */
  artifact: string;
  batchId: string;
  reportId: string;
  /**
   * Integration type: icm or rms
   */
  type: "icm" | "rms";
};

export type DownloadCatArtifactCatDownloadReportIdBatchIdGetResponse = unknown;

export type DownloadAllCatArtifactsZipCatDownloadAllReportIdBatchIdGetData = {
  batchId: string;
  reportId: string;
  /**
   * Integration type: icm or rms
   */
  type: "icm" | "rms";
};

export type DownloadAllCatArtifactsZipCatDownloadAllReportIdBatchIdGetResponse =
  unknown;

export type GetCatJobHistoryCatJobHistoryReportIdGetData = {
  reportId: string;
  /**
   * Integration type: icm or rms.
   */
  type?: "icm" | "rms";
};

export type GetCatJobHistoryCatJobHistoryReportIdGetResponse =
  CatJobHistoryResponse;

export type GetCatResultsCatResultsReportIdGetData = {
  batchId?: string | null;
  reportId: string;
};

export type GetCatResultsCatResultsReportIdGetResponse = CatResultsResponse;

export type AsgardIngestEmailAsgardIngestEmailPostData = {
  requestBody: {
    [key: string]: unknown;
  };
};

export type AsgardIngestEmailAsgardIngestEmailPostResponse = unknown;

export type AsgardIngestEmailSyncAsgardIngestEmailSyncPostData = {
  requestBody: IngestEmailSyncRequest;
};

export type AsgardIngestEmailSyncAsgardIngestEmailSyncPostResponse = unknown;

export type CalculatePremiumAsgardPremiumCalculatedPostData = {
  requestBody: CalculatePremiumRequest;
};

export type CalculatePremiumAsgardPremiumCalculatedPostResponse =
  CalculatedPremiumResponse;

export type AsgardRateSubmissionAsgardRateSubmissionPostData = {
  requestBody: RateSubmissionRequest;
};

export type AsgardRateSubmissionAsgardRateSubmissionPostResponse =
  RateSubmissionResponse;

export type DownloadRaterWorkbookRaterDownloadReportIdBatchIdGetData = {
  batchId: string;
  reportId: string;
};

export type DownloadRaterWorkbookRaterDownloadReportIdBatchIdGetResponse =
  unknown;

export type AsgardGenerateDocumenntAsgardGenerateDocumentPostData = {
  format?: "pdf" | "docx";
  formData: BodyAsgardGenerateDocumenntAsgardGenerateDocumentPost;
  reportId: string;
  templateOverrideId?: string | null;
  useCase:
    | "rater"
    | "proposal"
    | "binder"
    | "terrorism_declaration"
    | "property_declaration";
};

export type AsgardGenerateDocumenntAsgardGenerateDocumentPostResponse = unknown;

export type HealthcheckHealthcheckGetResponse = unknown;

export type LoginLoginPostData = {
  formData: BodyLoginLoginPost;
};

export type LoginLoginPostResponse = LoginResponse;

export type ListUsersListUsersPostResponse = ListUserResponse;

export type LogEventLogEventPostData = {
  requestBody: LogEventRequest;
};

export type LogEventLogEventPostResponse = unknown;

export type AsgardListReportsPostAsgardListReportsPostData = {
  requestBody: ListReportsRequest;
};

export type AsgardListReportsPostAsgardListReportsPostResponse =
  ListReportsResponse;

export type AsgardListReportAsgardListReportReportIdGetData = {
  reportId: string;
};

export type AsgardListReportAsgardListReportReportIdGetResponse =
  ReportResponse;

export type AsgardGoogleGroupStatsAsgardGoogleGroupStatsPostData = {
  requestBody: GoogleGroupStatsRequest;
};

export type AsgardGoogleGroupStatsAsgardGoogleGroupStatsPostResponse =
  GoogleGroupStats;

export type AsgardEmailThreadsAsgardEmailThreadsReportIdGetData = {
  reportId: string;
};

export type AsgardEmailThreadsAsgardEmailThreadsReportIdGetResponse =
  EmailThreadsResponse;

export type AsgardGenerateUnderwritingPdfAsgardGenerateUnderwritingPdfPostData =
  {
    requestBody: GenerateUnderwritingPdfRequest;
  };

export type AsgardGenerateUnderwritingPdfAsgardGenerateUnderwritingPdfPostResponse =
  unknown;

export type AsgardGenerateQuoteIndicationDraftAsgardGenerateQuoteIndicationDraftPostData =
  {
    requestBody: GenerateQuoteIndicationRequest;
  };

export type AsgardGenerateQuoteIndicationDraftAsgardGenerateQuoteIndicationDraftPostResponse =
  GmailDraftResponse;

export type AsgardDownloadLossRunAsgardDownloadLossRunPostData = {
  requestBody: DownloadLossRunRequest;
};

export type AsgardDownloadLossRunAsgardDownloadLossRunPostResponse = unknown;

export type AsgardUpdateReportAsgardUpdateReportPostData = {
  requestBody: UpdateReportRequest;
};

export type AsgardUpdateReportAsgardUpdateReportPostResponse =
  UpdateReportResponse;

export type AsgardAddManualAddressAsgardAddManualAddressPostData = {
  requestBody: AddManualAddressRequest;
};

export type AsgardAddManualAddressAsgardAddManualAddressPostResponse =
  AddManualAddressResponse;

export type AsgardAddCommentAsgardAddCommentPostData = {
  requestBody: AddCommentRequest;
};

export type AsgardAddCommentAsgardAddCommentPostResponse = AddCommentResponse;

export type AsgardDeleteReportAsgardDeleteReportPostData = {
  requestBody: DeleteReportRequest;
};

export type AsgardDeleteReportAsgardDeleteReportPostResponse =
  DeleteReportResponse;

export type AsgardUpdateAddressAsgardUpdateAddressPostData = {
  requestBody: UpdateAddressRequest;
};

export type AsgardUpdateAddressAsgardUpdateAddressPostResponse =
  UpdateAddressResponse;

export type AsgardDownload360ReportAsgardDownload360ReportPostData = {
  requestBody: Download360ReportRequest;
};

export type AsgardDownload360ReportAsgardDownload360ReportPostResponse =
  unknown;

export type AsgardSearchReportAddressesAsgardSearchReportAddressesPostData = {
  requestBody: SearchAddressRequest;
};

export type AsgardSearchReportAddressesAsgardSearchReportAddressesPostResponse =
  SearchAddressResponse;

export type AsgardListAdditionalFilesAsgardListAdditionalFilesReportIdPostData =
  {
    reportId: string;
  };

export type AsgardListAdditionalFilesAsgardListAdditionalFilesReportIdPostResponse =
  ListAdditionalFilesResponse;

export type AsgardDeleteAdditionalFilesAsgardDeleteAdditionalFilesReportIdPostData =
  {
    reportId: string;
    requestBody: DeleteAdditionalFilesRequest;
  };

export type AsgardDeleteAdditionalFilesAsgardDeleteAdditionalFilesReportIdPostResponse =
  DeleteAdditionalFilesResponse;

export type AsgardTestPythonFunctionAsgardTestPythonFunctionReportIdPostData = {
  reportId: string;
  requestBody: TestPythonFunctionRequest;
};

export type AsgardTestPythonFunctionAsgardTestPythonFunctionReportIdPostResponse =
  TestPythonFunctionResponse;

export type AsgardUploadAdditionalFileAsgardUploadAdditionalFilesPostData = {
  classificationForAllFiles?:
    | "sov_spreadsheet"
    | "acord_app"
    | "loss_run"
    | "none"
    | "screenshot"
    | "allied_policy"
    | "rater"
    | "loss_control_report"
    | "policy_document"
    | "specs_sheet"
    | "record_keeping"
    | null;
  formData: BodyAsgardUploadAdditionalFileAsgardUploadAdditionalFilesPost;
  reportId: string;
  sourceForAllFiles?: "email" | "screenshot_tool" | "user_upload";
};

export type AsgardUploadAdditionalFileAsgardUploadAdditionalFilesPostResponse =
  UploadAdditionalFilesResponse;

export type AsgardUploadEmlsAsgardUploadEmlsPostData = {
  formData: BodyAsgardUploadEmlsAsgardUploadEmlsPost;
  policyNumber: string;
};

export type AsgardUploadEmlsAsgardUploadEmlsPostResponse = unknown;

export type AsgardDownloadAdditionalFileAsgardDownloadAdditionalFilePostData = {
  requestBody: DownloadAdditionalFileRequest;
};

export type AsgardDownloadAdditionalFileAsgardDownloadAdditionalFilePostResponse =
  unknown;

export type GenerateBulkEditAsgardGenerateBulkEditPostData = {
  requestBody: BulkEditRequest;
};

export type GenerateBulkEditAsgardGenerateBulkEditPostResponse =
  BulkEditResponse;

export type DownloadReportFileAsgardDownloadReportFilePostData = {
  requestBody: DownloadReportFileRequest;
};

export type DownloadReportFileAsgardDownloadReportFilePostResponse = unknown;

export type DevDumpCoroutinesDevDumpCoroutinesPostResponse = {
  [key: string]: string;
};

export type CspReportCspReportPostResponse = unknown;

export type AsgardListSavedFiltersAsgardListSavedFiltersPostResponse =
  ListSavedFiltersResponse;

export type AsgardDeleteSavedFilterAsgardDeleteSavedFilterPostData = {
  requestBody: DeleteSavedFilterRequest;
};

export type AsgardDeleteSavedFilterAsgardDeleteSavedFilterPostResponse =
  ListSavedFiltersResponse;

export type AsgardUpdateSavedFilterAsgardUpdateSavedFilterPostData = {
  requestBody: UpdateSavedFilterRequest;
};

export type AsgardUpdateSavedFilterAsgardUpdateSavedFilterPostResponse =
  ListSavedFiltersResponse;

export type AsgardAddSavedFilterAsgardAddSavedFilterPostData = {
  requestBody: AddSavedFilterRequest;
};

export type AsgardAddSavedFilterAsgardAddSavedFilterPostResponse =
  ListSavedFiltersResponse;

export type AsgardLoadAddressesForMapAsgardLoadAddressesForMapPostData = {
  requestBody: LoadAddressesForMapRequest;
};

export type AsgardLoadAddressesForMapAsgardLoadAddressesForMapPostResponse =
  LoadAddressesForMapResponse;

export type AsgardEmlPreviewAsgardEmlPreviewPostData = {
  requestBody: EmlPreviewRequest;
};

export type AsgardEmlPreviewAsgardEmlPreviewPostResponse = EmlPreviewResponse;

export type AsgardDownloadReportHistoryAsgardDownloadReportHistoryPostData = {
  requestBody: DownloadReportHistoryRequest;
};

export type AsgardDownloadReportHistoryAsgardDownloadReportHistoryPostResponse =
  unknown;

export type AsgardListUpdatingReportsAsgardListUpdatingReportsPostData = {
  requestBody: ListUpdatingReportsRequest;
};

export type AsgardListUpdatingReportsAsgardListUpdatingReportsPostResponse =
  ListUpdatingReportsResponse;

export type AsgardListReportJobsAsgardListReportJobsPostData = {
  requestBody: ListReportJobsRequest;
};

export type AsgardListReportJobsAsgardListReportJobsPostResponse =
  ListReportJobsResponse;

export type AsgardCancelJobAsgardCancelJobPostData = {
  requestBody: CancelJobRequest;
};

export type AsgardCancelJobAsgardCancelJobPostResponse = CancelJobResponse;

export type AsgardGetSovOverviewAsgardGetSovOverviewPostData = {
  requestBody: GetSovOverviewRequest;
};

export type AsgardGetSovOverviewAsgardGetSovOverviewPostResponse =
  GetSovOverviewResponse;

export type AsgardGetAllSovPivotsAsgardGetAllSovPivotsPostData = {
  requestBody: GetAllSovPivotsRequest;
};

export type AsgardGetAllSovPivotsAsgardGetAllSovPivotsPostResponse =
  GetAllSovPivotsResponse;

export type AsgardListTemplatesAsgardListTemplatesPostResponse =
  ListTemplatesResponse;

export type AsgardDeleteTemplateAsgardDeleteTemplatePostData = {
  requestBody: DeleteTemplate;
};

export type AsgardDeleteTemplateAsgardDeleteTemplatePostResponse =
  ListTemplatesResponse;

export type AsgardUpdateTemplateAsgardUpdateTemplatePostData = {
  requestBody: UpdateTemplate;
};

export type AsgardUpdateTemplateAsgardUpdateTemplatePostResponse =
  ListTemplatesResponse;

export type AsgardCreateTemplateAsgardCreateTemplatePostData = {
  formData: BodyAsgardCreateTemplateAsgardCreateTemplatePost;
  useCase:
    | "rater"
    | "proposal"
    | "binder"
    | "terrorism_declaration"
    | "property_declaration";
};

export type AsgardCreateTemplateAsgardCreateTemplatePostResponse =
  ListTemplatesResponse;

export type AsgardDownloadTemplateAsgardDownloadTemplatePostData = {
  requestBody: DownloadTemplateRequest;
};

export type AsgardDownloadTemplateAsgardDownloadTemplatePostResponse = unknown;

export type AsgardGeneratePolicyNumbersAsgardGeneratePolicyNumbersPostData = {
  requestBody: GeneratePolicyNumbersRequest;
};

export type AsgardGeneratePolicyNumbersAsgardGeneratePolicyNumbersPostResponse =
  GeneratedPolicyNumbers;

export type AsgardGeneratePolicyFlyApplicationAsgardGeneratePolicyFlyApplicationPostData =
  {
    requestBody: GeneratePolicyFlyApplicationRequest;
  };

export type AsgardGeneratePolicyFlyApplicationAsgardGeneratePolicyFlyApplicationPostResponse =
  GeneratePolicyFlyApplicationResponse;

export type AsgardClearanceEmailRecipientsAsgardClearanceEmailRecipientsPostData =
  {
    requestBody: ClearanceEmailRecipientsRequest;
  };

export type AsgardClearanceEmailRecipientsAsgardClearanceEmailRecipientsPostResponse =
  ClearanceEmailRecipientsResponse;

export type AsgardSendClearanceEmailAsgardSendClearanceEmailPostData = {
  requestBody: SendClearanceEmailRequest;
};

export type AsgardSendClearanceEmailAsgardSendClearanceEmailPostResponse =
  GeneratedPolicyNumbers;

export type $OpenApiTs = {
  "/crm/contacts": {
    get: {
      res: {
        /**
         * Successful Response
         */
        200: ListContactsResponse;
      };
    };
  };
  "/crm/contact": {
    post: {
      req: CreateContactEndpointCrmContactPostData;
      res: {
        /**
         * Successful Response
         */
        200: CreateContactResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/crm/contact/{contact_id}": {
    post: {
      req: UpdateContactEndpointCrmContactContactIdPostData;
      res: {
        /**
         * Successful Response
         */
        200: UpdateContactResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/crm/broker_analytics": {
    get: {
      req: BrokerAnalyticsCrmBrokerAnalyticsGetData;
      res: {
        /**
         * Successful Response
         */
        200: GetBrokerAnalyticsResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/crm/broker_export": {
    post: {
      res: {
        /**
         * Successful Response
         */
        200: unknown;
      };
    };
  };
  "/asgard/list_report_action_logs": {
    post: {
      req: AsgardListReportActionLogsAsgardListReportActionLogsPostData;
      res: {
        /**
         * Successful Response
         */
        200: ListReportActionLogsResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/get_report_action_log": {
    post: {
      req: AsgardGetReportActionLogAsgardGetReportActionLogPostData;
      res: {
        /**
         * Successful Response
         */
        200: GetReportActionLogResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/icm/initiate": {
    post: {
      req: InitiateRequestEndpointIcmInitiatePostData;
      res: {
        /**
         * Successful Response
         */
        200: InitiateResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/icm/initiate_test": {
    post: {
      req: InitiateTestRequestEndpointIcmInitiateTestPostData;
      res: {
        /**
         * Successful Response
         */
        200: InitiateResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/icm/status/{request_id}": {
    get: {
      req: RequestStatusIcmStatusRequestIdGetData;
      res: {
        /**
         * Successful Response
         */
        200: StatusResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/rms/initiate": {
    post: {
      req: InitiateRmsRequestRmsInitiatePostData;
      res: {
        /**
         * Successful Response
         */
        200: RmsInitiateResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/rms/status/{request_id}": {
    get: {
      req: RmsRequestStatusRmsStatusRequestIdGetData;
      res: {
        /**
         * Successful Response
         */
        200: RmsStatusResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/cat/download/{report_id}/{batch_id}": {
    get: {
      req: DownloadCatArtifactCatDownloadReportIdBatchIdGetData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/cat/download_all/{report_id}/{batch_id}": {
    get: {
      req: DownloadAllCatArtifactsZipCatDownloadAllReportIdBatchIdGetData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/cat/job_history/{report_id}": {
    get: {
      req: GetCatJobHistoryCatJobHistoryReportIdGetData;
      res: {
        /**
         * Successful Response
         */
        200: CatJobHistoryResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/cat/results/{report_id}": {
    get: {
      req: GetCatResultsCatResultsReportIdGetData;
      res: {
        /**
         * Successful Response
         */
        200: CatResultsResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/ingest_email": {
    post: {
      req: AsgardIngestEmailAsgardIngestEmailPostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/ingest_email_sync": {
    post: {
      req: AsgardIngestEmailSyncAsgardIngestEmailSyncPostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/premium/calculated": {
    post: {
      req: CalculatePremiumAsgardPremiumCalculatedPostData;
      res: {
        /**
         * Successful Response
         */
        200: CalculatedPremiumResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/rate_submission": {
    post: {
      req: AsgardRateSubmissionAsgardRateSubmissionPostData;
      res: {
        /**
         * Successful Response
         */
        200: RateSubmissionResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/rater/download/{report_id}/{batch_id}": {
    get: {
      req: DownloadRaterWorkbookRaterDownloadReportIdBatchIdGetData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/generate_document": {
    post: {
      req: AsgardGenerateDocumenntAsgardGenerateDocumentPostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/healthcheck": {
    get: {
      res: {
        /**
         * Successful Response
         */
        200: unknown;
      };
    };
  };
  "/login": {
    post: {
      req: LoginLoginPostData;
      res: {
        /**
         * Successful Response
         */
        200: LoginResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/list_users": {
    post: {
      res: {
        /**
         * Successful Response
         */
        200: ListUserResponse;
      };
    };
  };
  "/log_event": {
    post: {
      req: LogEventLogEventPostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/list_reports": {
    post: {
      req: AsgardListReportsPostAsgardListReportsPostData;
      res: {
        /**
         * Successful Response
         */
        200: ListReportsResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/list_report/{report_id}": {
    get: {
      req: AsgardListReportAsgardListReportReportIdGetData;
      res: {
        /**
         * Successful Response
         */
        200: ReportResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/google_group_stats": {
    post: {
      req: AsgardGoogleGroupStatsAsgardGoogleGroupStatsPostData;
      res: {
        /**
         * Successful Response
         */
        200: GoogleGroupStats;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/email_threads/{report_id}": {
    get: {
      req: AsgardEmailThreadsAsgardEmailThreadsReportIdGetData;
      res: {
        /**
         * Successful Response
         */
        200: EmailThreadsResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/generate_underwriting_pdf": {
    post: {
      req: AsgardGenerateUnderwritingPdfAsgardGenerateUnderwritingPdfPostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/generate_quote_indication_draft": {
    post: {
      req: AsgardGenerateQuoteIndicationDraftAsgardGenerateQuoteIndicationDraftPostData;
      res: {
        /**
         * Successful Response
         */
        200: GmailDraftResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/download_loss_run": {
    post: {
      req: AsgardDownloadLossRunAsgardDownloadLossRunPostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/update_report": {
    post: {
      req: AsgardUpdateReportAsgardUpdateReportPostData;
      res: {
        /**
         * Successful Response
         */
        200: UpdateReportResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/add_manual_address": {
    post: {
      req: AsgardAddManualAddressAsgardAddManualAddressPostData;
      res: {
        /**
         * Successful Response
         */
        200: AddManualAddressResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/add_comment": {
    post: {
      req: AsgardAddCommentAsgardAddCommentPostData;
      res: {
        /**
         * Successful Response
         */
        200: AddCommentResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/delete_report": {
    post: {
      req: AsgardDeleteReportAsgardDeleteReportPostData;
      res: {
        /**
         * Successful Response
         */
        200: DeleteReportResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/update_address": {
    post: {
      req: AsgardUpdateAddressAsgardUpdateAddressPostData;
      res: {
        /**
         * Successful Response
         */
        200: UpdateAddressResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/download_360_report": {
    post: {
      req: AsgardDownload360ReportAsgardDownload360ReportPostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/search_report_addresses": {
    post: {
      req: AsgardSearchReportAddressesAsgardSearchReportAddressesPostData;
      res: {
        /**
         * Successful Response
         */
        200: SearchAddressResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/list_additional_files/{report_id}": {
    post: {
      req: AsgardListAdditionalFilesAsgardListAdditionalFilesReportIdPostData;
      res: {
        /**
         * Successful Response
         */
        200: ListAdditionalFilesResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/delete_additional_files/{report_id}": {
    post: {
      req: AsgardDeleteAdditionalFilesAsgardDeleteAdditionalFilesReportIdPostData;
      res: {
        /**
         * Successful Response
         */
        200: DeleteAdditionalFilesResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/test_python_function/{report_id}": {
    post: {
      req: AsgardTestPythonFunctionAsgardTestPythonFunctionReportIdPostData;
      res: {
        /**
         * Successful Response
         */
        200: TestPythonFunctionResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/upload_additional_files": {
    post: {
      req: AsgardUploadAdditionalFileAsgardUploadAdditionalFilesPostData;
      res: {
        /**
         * Successful Response
         */
        200: UploadAdditionalFilesResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/upload_emls": {
    post: {
      req: AsgardUploadEmlsAsgardUploadEmlsPostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/download_additional_file": {
    post: {
      req: AsgardDownloadAdditionalFileAsgardDownloadAdditionalFilePostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/generate_bulk_edit": {
    post: {
      req: GenerateBulkEditAsgardGenerateBulkEditPostData;
      res: {
        /**
         * Successful Response
         */
        200: BulkEditResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/download_report_file": {
    post: {
      req: DownloadReportFileAsgardDownloadReportFilePostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/dev/dump_coroutines": {
    post: {
      res: {
        /**
         * Successful Response
         */
        200: {
          [key: string]: string;
        };
      };
    };
  };
  "/csp-report": {
    post: {
      res: {
        /**
         * Successful Response
         */
        200: unknown;
      };
    };
  };
  "/asgard/list_saved_filters": {
    post: {
      res: {
        /**
         * Successful Response
         */
        200: ListSavedFiltersResponse;
      };
    };
  };
  "/asgard/delete_saved_filter": {
    post: {
      req: AsgardDeleteSavedFilterAsgardDeleteSavedFilterPostData;
      res: {
        /**
         * Successful Response
         */
        200: ListSavedFiltersResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/update_saved_filter": {
    post: {
      req: AsgardUpdateSavedFilterAsgardUpdateSavedFilterPostData;
      res: {
        /**
         * Successful Response
         */
        200: ListSavedFiltersResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/add_saved_filter": {
    post: {
      req: AsgardAddSavedFilterAsgardAddSavedFilterPostData;
      res: {
        /**
         * Successful Response
         */
        200: ListSavedFiltersResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/load_addresses_for_map": {
    post: {
      req: AsgardLoadAddressesForMapAsgardLoadAddressesForMapPostData;
      res: {
        /**
         * Successful Response
         */
        200: LoadAddressesForMapResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/eml_preview": {
    post: {
      req: AsgardEmlPreviewAsgardEmlPreviewPostData;
      res: {
        /**
         * Successful Response
         */
        200: EmlPreviewResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/download_report_history": {
    post: {
      req: AsgardDownloadReportHistoryAsgardDownloadReportHistoryPostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/list_updating_reports": {
    post: {
      req: AsgardListUpdatingReportsAsgardListUpdatingReportsPostData;
      res: {
        /**
         * Successful Response
         */
        200: ListUpdatingReportsResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/list_report_jobs": {
    post: {
      req: AsgardListReportJobsAsgardListReportJobsPostData;
      res: {
        /**
         * Successful Response
         */
        200: ListReportJobsResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/cancel_job": {
    post: {
      req: AsgardCancelJobAsgardCancelJobPostData;
      res: {
        /**
         * Successful Response
         */
        200: CancelJobResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/get_sov_overview": {
    post: {
      req: AsgardGetSovOverviewAsgardGetSovOverviewPostData;
      res: {
        /**
         * Successful Response
         */
        200: GetSovOverviewResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/get_all_sov_pivots": {
    post: {
      req: AsgardGetAllSovPivotsAsgardGetAllSovPivotsPostData;
      res: {
        /**
         * Successful Response
         */
        200: GetAllSovPivotsResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/list_templates": {
    post: {
      res: {
        /**
         * Successful Response
         */
        200: ListTemplatesResponse;
      };
    };
  };
  "/asgard/delete_template": {
    post: {
      req: AsgardDeleteTemplateAsgardDeleteTemplatePostData;
      res: {
        /**
         * Successful Response
         */
        200: ListTemplatesResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/update_template": {
    post: {
      req: AsgardUpdateTemplateAsgardUpdateTemplatePostData;
      res: {
        /**
         * Successful Response
         */
        200: ListTemplatesResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/create_template": {
    post: {
      req: AsgardCreateTemplateAsgardCreateTemplatePostData;
      res: {
        /**
         * Successful Response
         */
        200: ListTemplatesResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/download_template": {
    post: {
      req: AsgardDownloadTemplateAsgardDownloadTemplatePostData;
      res: {
        /**
         * Successful Response
         */
        200: unknown;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/generate_policy_numbers": {
    post: {
      req: AsgardGeneratePolicyNumbersAsgardGeneratePolicyNumbersPostData;
      res: {
        /**
         * Successful Response
         */
        200: GeneratedPolicyNumbers;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/generate_policy_fly_application": {
    post: {
      req: AsgardGeneratePolicyFlyApplicationAsgardGeneratePolicyFlyApplicationPostData;
      res: {
        /**
         * Successful Response
         */
        200: GeneratePolicyFlyApplicationResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/clearance_email_recipients": {
    post: {
      req: AsgardClearanceEmailRecipientsAsgardClearanceEmailRecipientsPostData;
      res: {
        /**
         * Successful Response
         */
        200: ClearanceEmailRecipientsResponse;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
  "/asgard/send_clearance_email": {
    post: {
      req: AsgardSendClearanceEmailAsgardSendClearanceEmailPostData;
      res: {
        /**
         * Successful Response
         */
        200: GeneratedPolicyNumbers;
        /**
         * Validation Error
         */
        422: HttpValidationError;
      };
    };
  };
};
